export enum Paths {
	Admin = "/admin",
	Login = "/login",
	Main = "/main",
	Report = "/report",
	Data = "/data",
	App = "/app",
	Account = "/account",
	CiriumScreen = "/select-service/cirium-service",
	BhashiniService = "/select-service/bhashini-service",
	DashboardService = "/select-service/dashboard-service",
	SelectService = "/select-service",
}
